import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import globals from '../globals'
import ServiceDetails from '../modules/ServiceDetails'
import SubNavigation from '../modules/SubNavigation'
import BuyUsageData from '../modules/BuyUsageData'
import Documents from '../modules/Documents'
import ChangePlanBroadband from '../modules/ChangePlanBroadband'
import ChangeMyIp from '../modules/ChangeMyIp'
import DataSource from '../DataSource'
import ChangePlanAdsl from '../modules/ChangePlanAdsl'
import PaymentInformation from '../modules/PaymentInformation'
import { EXETEL_URL, SERVICE_ADSL, SERVICE_FIBRE, SERVICE_NBN } from '../constants'
import UsageSummary from '../modules/UsageSummary'
import AjaxLoader from '../components/AjaxLoader'
import DailyUsage from '../modules/DailyUsage'
import ServiceHeading from '../modules/ServiceHeading'
import CustomLink from '../components/CustomLink'
import { connect } from 'react-redux'
import Error from '../components/Error'

class BroadbandService extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
		    isLoaded: false,
            serviceDetails: {},
            homeSecure: null,
            hasErrors: false
        }

        this.type = this.props.match.params.type
        this.serviceId = this.props.match.params.id
        this.supportedTypes = [SERVICE_NBN, SERVICE_ADSL, SERVICE_FIBRE]
        this.titles = {
            [SERVICE_NBN]: 'nbn&trade;',
            [SERVICE_ADSL]: 'ADSL Broadband',
            [SERVICE_FIBRE]: 'Fibre'
        }
    }

    componentDidMount () {
        if (!this.supportedTypes.includes(this.type)) {
            this.setState({ hasErrors: true })
        } else {
            this.getData()
        }
    }

    getData () {
        DataSource.getData(`/api/getService/broadband/${this.serviceId}`, result => {
            const homeSecure = result.serviceDetails.services.filter(item => item.type === 'homeSecure')
            this.setState({
                serviceDetails: { ...result, ...result.serviceDetails },
                homeSecure: homeSecure[0] ? homeSecure[0] : null,
                isLoaded: true
            })
            globals.animatePageIn(this.container)
        }, () => {
            this.setState({ isLoaded: true, hasErrors: true })
        })
    }

    getSubNav() {
        let subNav = [
		    { title: 'Usage summary', url: '' },
		    { title: 'Daily usage detail', url: '/daily-usage' },
		    { title: 'Service details', url: '/service-details' }
        ]

        if (!this.state.serviceDetails.isUnlimitedUsage) {
            subNav.push({ title: 'Buy more data', url: '/buy-data' })
        }

        subNav = [...subNav,
            { title: 'Change my plan', url: '/change-plan' },
            { title: 'My documents', url: '/my-documents' },
        ]

        if (this.canAccessChangeMyIpPage()) {
            subNav.push({title: 'Change my IP address', url: '/change-ip' })
        }

        return subNav
    }

    getUrl (url) {
        return `/my-services/${this.type}/${this.serviceId}/${url}`
    }

    canAccessChangeMyIpPage() {
        return !this.state.serviceDetails.isSuperBBRadius
    }

    render () {
        const Title = this.titles[this.type]

        const RenderMyUsage = () => {
            return (
                <UsageSummary
                    type={this.type}
                    serviceId={this.serviceId}
                    serviceDetails={this.state.serviceDetails}
                    getUrl={this.getUrl.bind(this)}
                />
            )
        }

        const RenderDailyUsage = () => {
            return (
                <DailyUsage
                    serviceId={this.serviceId}
                />
            )
        }

        const RenderServiceDetails = () => {
            return (
                <ServiceDetails
                    title={`My ${Title} service details`}
                    details={this.state.serviceDetails.data}
                />
            )
        }

        const RenderBuyUsageData = () => {
            return (
                <div>
                    <BuyUsageData
                        title='Buy more data'
                        type={this.type}
                        serviceId={this.serviceId}
                        serviceDetails={this.state.serviceDetails}
                        expires={this.state.serviceDetails.currentBillingCycleEnd}
                    />
                    <PaymentInformation />
                </div>
            )
        }

        const RenderDocuments = () => {
            return (
                <Documents
                    title='My documents'
                    type={this.type}
                    serviceId={this.serviceId}
                />
            )
        }

        const RenderChangeMyIp = () => {
            return (
                <ChangeMyIp
                    title='Change my IP address'
                    type={this.type}
                    serviceId={this.serviceId}
                />
            )
        }

        const RenderChangePlan = () => {
            if (this.type === SERVICE_NBN || this.type === SERVICE_FIBRE) {
                return (
                    <ChangePlanBroadband
                        type={this.type}
                        serviceId={this.serviceId}
                        serviceDetails={this.state.serviceDetails}
                        isNotSubscribedAndNotInFreeTrial={isNotSubscribedAndNotInFreeTrial()}
                        updateServiceDetails={this.getData.bind(this)}
                    />
                )
            } else if (this.type === 'adsl') {
                return (
                    <ChangePlanAdsl
                        serviceId={this.serviceId}
                        monthsRemaining={this.state.serviceDetails.monthsRemaining}
                        serviceDetails={this.state.serviceDetails}
                    />
                )
            }
        }

        const isNotSubscribedAndInFreeTrial = () => {
            return this.state.homeSecure && !this.state.homeSecure.isSubscribed && this.state.homeSecure.isTrial
        }

        const isNotSubscribedAndNotInFreeTrial = () => {
            return !this.state.homeSecure || (this.state.homeSecure && (!this.state.homeSecure.isSubscribed && !this.state.homeSecure.isTrial) || this.state.homeSecure.isCancelled)
        }

        const FlipToFibreCopy = (
            <div className='col-12 col-lg-6 mt-3 mt-lg-0 color-indigo text-center text-lg-right'>
                <p className='sub-bold font-medium m-0 mb-1' dangerouslySetInnerHTML={{ __html: globals.noWidows('Flip to Fibre™ when you change plan!') }} />
                <p className='m-0 font-small lh'>Change plan now to Family nbn™ 100/20Mbps (existing FTTN/B service) or Superfast nbn™ 250/25Mbps (existing FTTC service) or higher <br className='d-none d-lg-inline' />for a <span className='color-lime bold'>FREE Fibre-to-the-home connection upgrade</span>.</p>
            </div>
        )

        if (!this.state.isLoaded) {
		    return <AjaxLoader />
        }

        if (this.state.hasErrors) {
            return <Redirect push to='/' />
        }

        const HeadingContent = () => {
            if (this.state.serviceDetails.flipReady) {
                return FlipToFibreCopy
            } else if (this.props.residential) {
                return null
            }

            return ''
        }

        return (
            <div ref={el => this.container = el} style={{ opacity: 0 }}>
                <ServiceHeading
                    icon={`/images/icon-${this.type}.svg`}
                    type={this.type}
                    smallText={this.state.serviceDetails.address}
                    medText={this.state.serviceDetails.description}
                >
                    <HeadingContent />
                </ServiceHeading>

                <SubNavigation
                    title='Manage my service'
                    items={this.getSubNav()}
                    url={this.props.match.url}
                    className={`gtm-service-manage-tab-click ${this.state.serviceDetails.isUnlimitedUsage ? 'flex-basis-30' : 'flex-basis-25'}`}
                />

                <Switch>
                    <Route exact path={this.props.match.url} render={RenderMyUsage} />
                    <Route exact path={`${this.props.match.url}/daily-usage`} render={RenderDailyUsage} />
                    <Route exact path={`${this.props.match.url}/service-details`} render={RenderServiceDetails} />
                    <Route exact path={`${this.props.match.url}/buy-data`} render={RenderBuyUsageData} />
                    <Route exact path={`${this.props.match.url}/change-plan`} render={RenderChangePlan} />
                    <Route exact path={`${this.props.match.url}/my-documents`} render={RenderDocuments} />
                    {this.canAccessChangeMyIpPage() ? (
                        <Route
                            exact
                            path={`${this.props.match.url}/change-ip`}
                            render={RenderChangeMyIp}
                        />
                    ) : (
                        <Route exact path={`${this.props.match.url}/change-ip`}>
                            <Redirect to={this.props.match.url} />
                        </Route>
                    )}
                </Switch>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    residential: state.auth.residential
})

export default connect(mapStateToProps, {})(BroadbandService)



// WEBPACK FOOTER //
// ./resources/js/services/BroadbandService.js